const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_app/$lang.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, notFound } from "@tanstack/react-router";
import { localeSchema } from "@garimpa/lib/localeSchema";
export const Route = createFileRoute("/_app/$lang")({
  beforeLoad: ({
    params
  }) => {
    const locale = localeSchema.safeParse(params.lang);
    if (!locale.success) throw notFound();
    return {
      routeLocale: locale.data,
      locale: locale.data
    };
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});